import { createAsyncThunk } from '@reduxjs/toolkit';
import { _reportSettingsUrls } from '@custom/Utils/constants/apiUrls';

const reportsSettingsApi = createAsyncThunk('reportsSettingsApi', async (body:any) => {
  try {
    const hospitalId=sessionStorage.getItem("hospitalId") || localStorage.getItem('hospitalId');
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${_reportSettingsUrls.get}?hospitalId=${hospitalId}`
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default reportsSettingsApi;
